// OVERHANG_ROW_COUNT specifies how many rows should be rendered on each side outside of the visible area
// there has to be some rows for the TABbing to work correctly
// if there isn't row rendered in the DOM, browser can't jump to it when tabbing
export const OVERHANG_ROW_COUNT = 2;
export const NEW_ROW_ID = "newRow";